import React from 'react';
import * as moment from 'moment';

import { parseSlug } from '../archives-utils/archivesUtils';
import play from '../../../assets/icons/play-54-4b7fa8b71484507993b8958a4124dcce.png';


class Arhive extends React.Component {

  render() {
    const { arhive, typeOfListing, listingId, slug, searchFullText } = this.props;
    const imageLink = (arhive.clipView && arhive.clipView.thumbnailImageUrl) ? arhive.clipView.thumbnailImageUrl : arhive.image;
    const date = arhive.publishedAt ? arhive.publishedAt : arhive.date;
    const title = arhive.title ? arhive.title : arhive.name;
    const parsedSlug = parseSlug(arhive, typeOfListing, listingId, slug, searchFullText);
    const utcDate = moment(date).utc();

    return (
      <div className="col-md-3 col-sm-4 col-xs-12">
        <div className="bg-white thumbnail">
          <a className="lazy video" href={parsedSlug}>
            <img
              alt="Xlthumb placeholder"
              className="img-responsive video-thumbnail"
              src={imageLink}
              style={{ opacity: 1 }}
            />
            <img
              alt="Play 54"
              className="play-icon"
              src={play}
            />
          </a>
          <div className="caption">
            {typeOfListing === 'date' || typeOfListing === 'all' ? (
              <a href={parsedSlug}>{utcDate.format('dddd, LL')}</a>
            ) : (
              <>
                <a href={parsedSlug}>{title}</a>
                {typeOfListing !== 'vintage' && (
                  <small className="text-muted">{utcDate.format('dddd LL')}</small>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Arhive;
